export default "__VITE_ASSET__DoeXZG9R__"